export default {"src":"/_next/static/media/Close-red.d1229466.svg","height":24,"width":24};